import React from "react";
import {
  Box,
  Button,
  Grid2,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";

// import dashboard from "../../../../Images/safetyWalk/dashboard.png";
// import formList from "../../../../Images/safetyWalk/formlist.png";
// import formPage from "../../../../Images/safetyWalk/formpage.png";
// import wave from "../../../../Images/aboutUsBg.jpg";
// import wave from "../../../../Images/aboutUsBg.jpg";
import { commonCss } from "../../../../CssStyle/commonCss";
import WaveBackground from "../../../../Component/WaveBackground";
import { Done } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const SafetyWalk = () => {
  const navigate = useNavigate();
  return (
    <Grid2 container spacing={"2rem"}>
      <WaveBackground
        menu={"Our Products"}
        title={"Safety Walk"}
        description={"Enhancing Workplace Safety Through Digital Inspections"}
      />

      <Grid2 container justifyContent={"center"}>
        <Grid2
          container
          size={12}
          spacing={"1rem"}
          sx={{
            padding: { xs: "1.5rem", md: "0 3rem 3rem 3rem" },
            maxWidth: { xs: "auto", xl: "2000px" },
          }}
          alignItems={"center"}
          mt="-10%"
        >
          <Grid2
            container
            size={{ xs: 12, md: 6 }}
            justifyContent={{ xs: "center", md: "flex-start" }}
          >
            <img
              src={"/Images/safetyWalk/dashboard.png"}
              alt="Safety Walk dashboard"
              style={{ width: "85%", height: "100%" }}
            />
          </Grid2>
          <Grid2
            size={{ xs: 12, md: 6 }}
            sx={{
              pr: {
                xs: 0,
                md: "3rem",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "35px", md: "40px" },
                textAlign: { xs: "center", md: "left" },
                fontWeight: 700,
                fontFamily: "inherit",
              }}
            >
              Industrial Safety Walk Web App & Mobile App
            </Typography>
            <Typography
              variant="h1"
              sx={{
                letterSpacing: 0.3,
                lineHeight: 1.5,
                fontWeight: 300,
                fontFamily: "inherit",
                fontSize: "20px",
                mt: "1rem",
              }}
            >
              A{" "}
              <span style={{ color: commonCss.orange, fontWeight: 600 }}>
                Safety Walk
              </span>{" "}
              is a digital platform designed to streamline safety inspections,
              audits, and reporting processes in workplaces. It typically helps
              organizations ensure compliance with safety standards, identify
              hazards, and promote a safer environment.
            </Typography>

            <Typography
              sx={{
                fontSize: "1.1rem",
                fontWeight: 700,
                fontFamily: "inherit",
                mt: 4,
              }}
            >
              Key Features
            </Typography>
            <List
              sx={{
                "& .MuiListItemText-primary": {
                  fontFamily: "Roboto, sans-serif",
                  fontSize: "1rem",
                  fontWeight: 600,
                },
                display: "flex",
                columnGap: "1rem",
                flexWrap: "wrap",
                width: "100%",
                mt: 1,
              }}
            >
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Inspection & Audits</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Incident Reporting</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Checklists & Guidelines</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Data Tracking & Analytics</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Corrective Actions</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Compliance Management</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Employee Engagement</ListItemText>
              </ListItem>
            </List>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2
        container
        justifyContent={"center"}
        sx={{ background: commonCss.backgroundGray }}
      >
        <Grid2
          container
          size={12}
          spacing={"1rem"}
          sx={{
            padding: { xs: "1.5rem", md: "3rem" },
            maxWidth: { xs: "auto", md: "2000px" },
          }}
          alignItems={"center"}
        >
          <Grid2
            size={{ xs: 12, md: 6 }}
            sx={{
              pl: {
                xs: 0,
                md: "3rem",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "35px", md: "40px" },
                fontWeight: 700,
                fontFamily: "inherit",
              }}
            >
              Are you struggling with registering your safety findings and
              resolving the issue efficiently?
            </Typography>
            <Typography
              variant="h1"
              sx={{
                letterSpacing: 0.3,
                lineHeight: 1.5,
                fontWeight: 300,
                fontFamily: "inherit",
                fontSize: "20px",
                mt: "1rem",
              }}
            >
              Look no further than our Safety Walk solution.
            </Typography>

            {/* <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Key Features</Typography> */}
            <List
              sx={{
                "& .MuiListItemText-primary": {
                  fontFamily: "Roboto, sans-serif",
                  fontSize: "1rem",
                  fontWeight: 600,
                },
                display: "flex",
                columnGap: "1rem",
                flexWrap: "wrap",
                width: "100%",
                mt: 4,
              }}
            >
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Ability to report safety findings digitally
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Digitally route for multiple approvals
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Ability to attach images of the findings
                </ListItemText>
              </ListItem>
            </List>
          </Grid2>
          <Grid2
            container
            size={{ xs: 12, md: 6 }}
            justifyContent={{ xs: "center", md: "flex-end" }}
          >
            <img
              src={"/Images/safetyWalk/formlist.png"}
              alt="Safety Walk form list"
              style={{ width: "85%", height: "100%" }}
            />
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 container justifyContent={"center"}>
        <Grid2
          container
          size={12}
          spacing={"1rem"}
          sx={{
            padding: { xs: "1.5rem", md: "3rem 3rem 1rem 3rem" },
            maxWidth: { xs: "auto", xl: "2000px" },
          }}
          alignItems={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 6 }}
            justifyContent={{ xs: "center", md: "flex-start" }}
          >
            <img
              src={"/Images/safetyWalk/formpage.png"}
              alt="Safety Walk form page"
              style={{ width: "85%", height: "100%" }}
            />
          </Grid2>
          <Grid2
            size={{ xs: 12, md: 6 }}
            sx={{
              pr: {
                xs: 0,
                md: "3rem",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "35px", md: "40px" },
                fontWeight: 700,
                fontFamily: "inherit",
              }}
            >
              Benefits
            </Typography>
            {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
            <List
              sx={{
                "& .MuiListItemText-primary": {
                  fontFamily: "Roboto, sans-serif",
                  fontSize: "1.1rem",
                  fontWeight: 400,
                },
                display: "flex",
                columnGap: "1rem",
                flexWrap: "wrap",
                width: "100%",
                mt: 1,
              }}
            >
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Enhances workplace safety and compliance.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Streamlines data collection and reporting.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Reduces paperwork with digital records.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Improves team communication with task tracking and alerts.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Access to historical safety e-Forms</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Interactive dashboards & KPIs</ListItemText>
              </ListItem>
            </List>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2
        size={12}
        container
        justifyContent={"flex-end"}
        sx={{ p: "0rem 2rem 2rem 0rem", width: { xs: "auto", xl: "2000px" } }}
      >
        <Button
          sx={{
            backgroundColor: commonCss.buttonBg,
            color: commonCss.buttonText,
            padding: "0.5rem 2rem",
            textTransform: "none",
            width: "fit-content",
            fontWeight: 500,
            fontSize: "0.95rem",
            borderRadius: "30px",
            ":hover": {
              background: commonCss.blue,
            },
            //  position: 'relative',
            //   transition: '0.3s',
            //     animation: 'glow 1.5s infinite alternate',

            //   '@keyframes glow': {
            //     '0%': {
            //       background: "#FCAE1E",
            //     },
            //     '100%': {
            //       background: commonCss.blue,
            //     },
            //   },
          }}
          onClick={() => {
            navigate("/products?productName=safetywalk");
          }}
        >
          Explore More Products
        </Button>
        <Button
          sx={{
            backgroundColor: commonCss.buttonBg,
            color: commonCss.buttonText,
            padding: "0.5rem 2rem",
            textTransform: "none",
            width: "fit-content",
            fontWeight: 500,
            fontSize: "0.95rem",
            borderRadius: "30px",
            ":hover": {
              background: commonCss.blue,
            },
            position: "relative",
            transition: "0.3s",
            animation: "glow 1.5s infinite alternate",

            "@keyframes glow": {
              "0%": {
                background: "#FCAE1E",
              },
              "100%": {
                background: commonCss.blue,
              },
            },
          }}
          onClick={() => {
            navigate("/contactus?type=Product Demo&&demo=Safety Walk");
          }}
        >
          Schedule a Demo
        </Button>
      </Grid2>
    </Grid2>
  );
};

export default SafetyWalk;
